var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#037f06;}.cls-2{fill:#f9f9f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,4h0A11,11,0,0,1,26,15h0A11,11,0,0,1,15,26h0A11,11,0,0,1,4,15H4A11,11,0,0,1,15,4Z",
    transform: "translate(-4 -4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.05 4.05 17.05 17.95 7.53 11.18 7.53 9.27 15.46 15.17 15.46 7.17 13.65 8.53 11.1 6.85 13.46 6.61 17.05 4.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.47 10.82 14.47 12.73 6.54 6.83 6.54 14.83 8.27 13.44 11.27 15.39 8.9 15.14 4.95 17.95 4.95 4.05 14.47 10.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestnet);
export default __webpack_public_path__ + "static/media/testnet.4f3a7563fb9208cc981f256ec1fdd1b7.svg";
export { ForwardRef as ReactComponent };